import { searchEditors } from '../../../../services/case-plan-create.service';
import { useDebouncedPeopleSearch } from '../../useDebouncedPeopleSearch';

/**
 * Debounced staff/editor search for the Create Plan editors autocomplete.
 */
export const useEditorSearchHook = () => useDebouncedPeopleSearch(searchEditors);
